/**
 * Add to Cart with Delay functionality
 * Intercepts form submission, adds item via AJAX, waits for discount app processing, then redirects
 */
window.theme = window.theme || {};

theme.initAddToCartWithDelay = function() {
  // Configuration - adjust delay time as needed (in milliseconds)
  var DELAY_TIME = 2000; // 2 seconds delay
  
  // Select all add to cart forms
  var $addToCartForms = $('form[action="/cart/add"]');
  
  if (!$addToCartForms.length) {
    return;
  }
  
  $addToCartForms.on('submit', function(e) {
    e.preventDefault(); // Prevent default form submission
    
    var $form = $(this);
    var $submitButton = $form.find('button[type="submit"], input[type="submit"]');
    var originalButtonText = $submitButton.find('span').text() || $submitButton.val();
    
    // Disable button and show loading state
    $submitButton.prop('disabled', true);
    $submitButton.find('span').text('Adding...');
    
    // Get form data
    var formData = $form.serialize();
    
    // Add item to cart via AJAX
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(response) {
        // Success - wait for discount app to process
        setTimeout(function() {
          // Redirect to cart page
          window.location.href = '/cart';
        }, DELAY_TIME);
      },
      error: function(xhr, status, error) {
        // Error handling - re-enable button and show error
        $submitButton.prop('disabled', false);
        $submitButton.find('span').text(originalButtonText);
        
        // Try to parse error message
        var errorMessage = 'Unable to add item to cart';
        try {
          var errorData = JSON.parse(xhr.responseText);
          if (errorData.description) {
            errorMessage = errorData.description;
          }
        } catch (e) {
          // Use default error message
        }
        
        // Show error message (you can customize this)
        alert(errorMessage);
      }
    });
  });
};

// Initialize when document is ready
$(document).ready(function() {
  theme.initAddToCartWithDelay();
});
